import React from 'react';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';
import { theme } from '../Theme';
import { toRem } from '../../helpers';
import { ReactComponent as Cart } from '../../assets/svg/Cart.svg';
import { StyledSpinner } from './Button';

const Button = styled('button')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colorScheme.black};
  border: 2px solid ${theme.colorScheme.black};
  color: ${theme.colorScheme.white};
  font-size: ${toRem(14)};
  font-weight: ${theme.fontWeights.medium};
  border-radius: ${toRem(100)};
  padding: 0.5rem 1rem;

  span {
    margin-right: ${toRem(12)};
  }
  svg {
    position: relative;
    fill: ${theme.colorScheme.white};
    height: 1em;
    width: 1em;
    margin-left: ${toRem(10)};
    path {
      fill: ${theme.colorScheme.white};
    }
  }
  ${theme.above.md} {
    max-width: 100%;
  }

  :disabled {
    border: 1px solid #dedede;
    opacity: 0.5;
    cursor: not-allowed;
  }

  :hover:enabled {
    background-color: ${theme.colorScheme.primary};
    border: 2px solid ${theme.colorScheme.primary};
    color: ${theme.colorScheme.primarytext};
    svg {
      fill: ${theme.colorScheme.primarytext};
      path {
        fill: ${theme.colorScheme.primarytext};
      }
    }
  }
`;

const AddToCartButton = ({
  loading,
  loadingText = t('Hold on a moment...'),
  children,
  size,
  ...props
}) =>
  loading ? (
    <Button {...props}>
      <span>{loadingText}</span>
      <StyledSpinner />
    </Button>
  ) : (
    <Button {...props} size={size}>
      {children}
      <Cart />
    </Button>
  );

export default AddToCartButton;
